enum RpcCallStatus {
    UNINITIALIZED,
    LOADING,
    SUCCESS,
    ERROR
}

//This has to be in another line, see: https://github.com/microsoft/TypeScript/issues/3320
export default RpcCallStatus
